
import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {NgxDatatableModule} from "@swimlane/ngx-datatable";
import {FlexLayoutModule} from "@angular/flex-layout";
import {MatFormFieldModule} from "@angular/material/form-field";
import {MatIconModule} from "@angular/material/icon";
import {MatInputModule} from "@angular/material/input";
import {MatButtonModule} from "@angular/material/button";
import {FuseSharedModule} from "../../../@fuse/shared.module";
import {FuseHighlightModule, FuseSidebarModule} from "../../../@fuse/components";
import {MatRippleModule} from "@angular/material/core";
import {MatCheckboxModule} from "@angular/material/checkbox";
import {MatSelectModule} from "@angular/material/select";
import {MatDialogModule} from "@angular/material/dialog";
import {MatToolbarModule} from "@angular/material/toolbar";
import {RouterModule} from "@angular/router";
import {SupplierOrderModule} from "../supplierOrder/supplierOrder.module";
import {TranslateModule} from "@ngx-translate/core";
import {PosComponent} from "./pos.component";
import {PosMainSidebarComponent} from "./sidebars/main/main-sidebar.component";
import {ReceiptMainSidebarComponent} from "./sidebars/receipt/receipt-sidebar.component";
import {AdditionalProductInfoDialogComponent} from "./dialog/additionalProductInfoDialog.component";
import {AdditionalVoucherInfoDialogComponent} from "./dialog/additionalVoucherInfoDialog.component";
import {PosNavbarComponent} from "./navbar/posNavbar.component";
import {SelectCustomerDialogComponent} from "./dialog/selectCustomerDialog/selectCustomerDialog.component";
import {MatAutocompleteModule} from "@angular/material/autocomplete";
import {ConfirmBillPrintDialogComponent} from "./dialog/confirmBillPrintDialog/confirmBillPrintDialog.component";
import {RequiredCustomerDialogComponent} from "./dialog/requiredCustomerDialog/requiredCustomerDialog.component";
import {DiscountsDialogComponent} from "./dialog/discountsDialog/discountsDialog.component";
import {SplitPaymentDialogComponent} from "./dialog/splitPaymentDialog/splitPaymentDialog.component";
import {VirtualReceipt} from "./model/virtualReceipt";
import {VirtualReceiptComponent} from "./virtualReceipt.component";
import {FiscalPrinterInactiveDialogComponent} from "./dialog/fiscalPrinterInactiveDialog/fiscalPrinterInactiveDialog.component";

@NgModule({
    declarations: [
        PosComponent,
        PosMainSidebarComponent,
        ReceiptMainSidebarComponent,
        AdditionalProductInfoDialogComponent,
        AdditionalVoucherInfoDialogComponent,
        ConfirmBillPrintDialogComponent,
        RequiredCustomerDialogComponent,
        PosNavbarComponent,
        SelectCustomerDialogComponent,
        DiscountsDialogComponent,
        SplitPaymentDialogComponent,
        VirtualReceiptComponent,
        FiscalPrinterInactiveDialogComponent,
    ],
    imports: [
        RouterModule,
        BrowserModule,
        BrowserAnimationsModule,
        FormsModule,
        ReactiveFormsModule,
        NgxDatatableModule,
        FlexLayoutModule,
        MatFormFieldModule,
        MatIconModule,
        MatInputModule,
        MatButtonModule,

        FuseSharedModule,
        FuseSidebarModule,
        MatRippleModule,
        MatCheckboxModule,
        MatSelectModule,
        MatDialogModule,
        MatToolbarModule,
        SupplierOrderModule,
        TranslateModule,
        FuseHighlightModule,
        MatAutocompleteModule,
    ],
    providers: [],
    exports: [
        PosNavbarComponent,
    ],
    bootstrap: [
        PosComponent,
        AdditionalProductInfoDialogComponent,
        AdditionalVoucherInfoDialogComponent,
        VirtualReceiptComponent,
        FiscalPrinterInactiveDialogComponent,
    ]
})
export class PosModule { }
